import React from 'react';
import SlabLogo from '../../components/SlabLogo';
import * as styles from './ExtensionErrorBoundary.module.scss';

interface ExtensionErrorBoundaryProps {
  errorMessage: React.ReactNode;
}

const ExtensionErrorBoundary = ({
  errorMessage,
}: ExtensionErrorBoundaryProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <SlabLogo className={styles.logo} />
        <div className={styles.message}>{errorMessage}</div>
      </div>
    </div>
  );
};

export default ExtensionErrorBoundary;
